import React, { useEffect, useState } from "react";
import { DataGridPro as DataGrid } from "@mui/x-data-grid-pro";
import { getTasksColumns } from "../components/grids/tasksGrid.js";
import Box from "@mui/material/Box";
import { useSelector } from "react-redux";
import Modal from "../components/widgets/Modal.js";
import { parseTasks } from "../utils/utils.js";
import { Button } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import ConfirmDialog from "../components/widgets/ConfirmDialog.js";
import MapPage from "./MapPage.js";
import { CALL_HANDLER, CONTROL_TOWER } from "../utils/config";
import AddIcCallIcon from '@mui/icons-material/AddIcCall';

const TasksPage = () => {
  const navigate = useNavigate();
  const { patrolId } = useParams();
  const [selectedEntityId, setSelectedEntityId] = useState(null);
  const [openCloseWindow, setOpenCloseWindow] = useState(false);
  const [formIsDirty, setFormIsDirty] = useState(false);
  const constants = useSelector(state => state.constants.data);
  let rows = parseTasks(useSelector((state) => state.tasks.filteredTasks), constants) || [];
  const [showModal, setShowModal] = useState(false);
  const [renderGrid, setRenderGrid] = useState(false);
  const [mapEntityId, setMapEntityId] = useState(null);
  const [mapEntityType, setMapEntityType] = useState('TASK');
  const [modalType, setModalType] = useState(null);
  const { roles } = useSelector((state) => state.auth) || [];
  //const taskStatuses = useSelector((state) => state.constants.data.taskStatuses);
  //const completedStatusId = taskStatuses.find(t => t.code == 'COMP')?.id;
  const isCH = roles.includes(CALL_HANDLER) && !roles.includes(CONTROL_TOWER);

  const selectedEntity = useSelector(state => 
  {
      let entityPool;
      
      if(modalType == 'TASK') {
        entityPool = state.tasks.filteredTasks;
      } 
    
      if(modalType == 'PATROL') {
        entityPool = state.patrols.filteredPatrols;
      } 
      return selectedEntityId != null
      ? entityPool.find(t => t.id == selectedEntityId)
      : null;
    }
  );

  let filteredRows = rows;
  // if(!isCH || (isCH && !showCompleted)) {
  //   //console.log('SHOW COMP', completedStatusId);
  //   filteredRows = rows.filter(r => r.statusId != completedStatusId);
  // } 

  const handleRowClick = (params) => {
    setSelectedEntityId(params.row.id); 
    setShowModal(true);
    setModalType('TASK');
  };

  const handleAddTask = () => {
    setModalType('TASK');
    setSelectedEntityId(null);
    setShowModal(true);
  }

  useEffect(() => {
    //DataGrid bug fix - won't render the first time and complains about row.id
    setTimeout(() => {
      setRenderGrid(true);
      if(patrolId) {
        setMapEntityId(patrolId);
        setMapEntityType('PATROL');
      }
    }, 100);
  }, []);

  function renderLocation(params) {
    const handleOpen = (e) => {
      
      e.stopPropagation();
      e.preventDefault();
      setMapEntityType('TASK');
      navigate('/tasks')
      setMapEntityId(params.row.id);
    }
    return (<a href="#" onClick={handleOpen}>Open Map</a>)
  }
  
  const locationColumn = {
    field: 'breakdownLocation',
    filterable: false,
    sortable: false,
    headerName: 'Location', 
    headeralign: 'left',
    align: 'left',
    flex: 1,
    maxWidth: 100,
    renderCell: (params) => renderLocation(params),
  };

  const handleClose = () => {
    setSelectedEntityId(null); 
    setShowModal(false);
    setOpenCloseWindow(false);
  }

  const columns = [...getTasksColumns(constants.taskTypes,constants.taskStatuses, constants.vehicleMakes, constants.vehicleModels, constants.vehicleFaults)];
  if(!isCH) {
    columns.unshift(locationColumn);
  }

  const [paginationModel, setPaginationModel] = useState({page: 0, pageSize: 20});
  
  return (
    <Box sx={{
      display: 'flex',
      padding: '20px',
      width: "100%",
      flexDirection: {xs: 'column', ['@media (min-width:2400px)']:{flexDirection: 'row'}},
      gap: 2
    }}>
      <Box sx={{ flex: 1 }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between'
          }}
        >
          <Button startIcon={<AddIcCallIcon />} onClick={handleAddTask} sx={{p: '0 15px', mb: 1, mt: 1, background: 'var(--template-palette-action-selected)'}}> Create a Task </Button>
          
        </Box>
        {renderGrid && <DataGrid
          sx={{ width: 1 }}
          //key={filteredRows.length}
          rows={filteredRows}
          columns={columns}
          onRowClick={handleRowClick}
          pagination
          paginationModel= {paginationModel}
          onPaginationModelChange={setPaginationModel}
          pageSizeOptions={[10, 20, 50]}
          disableColumnResize
          density="compact"
          slotProps={{
            filterPanel: {
              filterFormProps: {
                logicOperatorInputProps: {
                  variant: "outlined",
                  size: "small",
                },
                columnInputProps: {
                  variant: "outlined",
                  size: "small",
                  sx: { mt: "auto" },
                },
                operatorInputProps: {
                  variant: "outlined",
                  size: "small",
                  sx: { mt: "auto" },
                },
                valueInputProps: {
                  InputComponentProps: {
                    variant: "outlined",
                    size: "small",
                  },
                },
              },
            },
          }}
        />}

        <ConfirmDialog
          open={openCloseWindow}
          //open={!!selectedEntity}
          confirmAction={handleClose}
          confirmLabel="Close window"
          cancelLabel="Cancel"
          cancelAction={() => { setOpenCloseWindow(false) }}
        >
          <p>You have unsaved changes. Are you sure you want to close this window?</p>
        </ConfirmDialog>

        {showModal && <Modal
          type={modalType}
          open={showModal}
          setFormIsDirty={setFormIsDirty}
          onClose={(isDirtyCheckNeeded = true) => {
            if(formIsDirty && isDirtyCheckNeeded) {
              setOpenCloseWindow(true);
            } else {
              handleClose();
            }
          }}
          //onClose={() => setSelectedEntity(null)}
          entity={selectedEntity}
        />}
      </Box>

      <Box sx={{ flex: 1 }}>
        { !isCH  && <MapPage setShowModal={setShowModal} setSelectedEntityId={setSelectedEntityId} setModalType={setModalType} entityId={mapEntityId} entityType={mapEntityType} /> }
      </Box>
    </Box>
  );
};

export default TasksPage;
